import { Injectable, inject } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';

import { catchError, map, of, switchMap } from 'rxjs';

import { BorrowerDashboardService } from '@views/borrower/borrower.service';

import { SnackBarService } from '@components/sq-snackbar/sq-snackbar.service';

import { AuthService } from '../auth/auth.service';
import * as actions from './constants.actions';
import { ConstantsService } from './constants.service';

@Injectable()
export class Effects {
  private actions$ = inject(Actions);
  private constantsService = inject(ConstantsService);
  private borrowerService = inject(BorrowerDashboardService);
  private snackBarService = inject(SnackBarService);
  private authService = inject(AuthService);

  fetchInvestorConstants$ = createEffect(() =>
    this.actions$.pipe(
      ofType(actions.constantsFetchInvestorStart),
      switchMap(() => {
        return this.constantsService.fetchList().pipe(
          map(payload => {
            return actions.constantsFetchInvestorSuccess({ payload });
          }),
          catchError(() => {
            this.snackBarService.setError('Sorry, there has been an issue fetching your page');
            return of(actions.constantsFetchInvestorFail());
          }),
        );
      }),
    ),
  );

  fetchLBorrowerConstants$ = createEffect(() =>
    this.authService.createGenericRequest({
      actions$: this.actions$,
      makeRequest: () => this.borrowerService.getBorrowerDashboard(),
      errorMessage: 'Sorry, there has been an issue fetching your page',
      startAction: actions.constantsFetchBorrowerStart,
      successAction: actions.constantsFetchBorrowerSuccess,
      failAction: actions.constantsFetchBorrowerFail,
    }),
  );

  fetchActiveInvestors$ = createEffect(() =>
    // Doesn't use network layer as does not need authorization
    this.actions$.pipe(
      ofType(actions.constantsFetchActiveInvestorsStart),
      switchMap(() => {
        return this.constantsService
          .fetchActiveInvestors({
            id: 'activeInvestors_v1',
          })
          .pipe(
            map(payload => {
              return actions.constantsFetchActiveInvestorsSuccess({ payload });
            }),
            catchError(() => {
              return [actions.constantsFetchActiveInvestorsFail()];
            }),
          );
      }),
    ),
  );
}
